<template>
  <div class="" style="">
      <div class="topImgContent">
          <div class="topImgTitleContent">
              <div class="topImgTitle">政策解读</div>
              <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
              <div class="e-flex menuContent">
                  <img class="ic_home" src="@/assets/images/ic_home.png">
                  <div class="pointer" @click="goMainPage()">首页</div>
                  <div>/</div>
                  <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/twoRegionPolicy/policyInterpretation', query: {}})">政策解读</div>
                  <div>/</div>
                  <div>正文</div>
              </div>
          </div>
      </div>
      <div class="e-flex trpsd_detailContent">
          <div class="trpsd_detailContentWhite">
              <div class="trpsd_detailTop">
                  <div class="trpsd_detailTitle" v-html="info ? info.title : ''"></div>
                  <div class="trpsd_detailDate">{{ info ? info.publishDate.replace('-','年').replace('-','月') + '日' : '' }}</div>
              </div>
              <div class="trpsd_detailContentText" v-html="info ? info.content : ''"></div>
              <div class="trpsd_fileContent e-flex" v-if="info && info.attach.length != 0" @click="viewPdf(info.attach[0].url)">
                <img class="trpsd_fileIcon" src="@/assets/images/ic_file.png">
                <div class="e-line-1">{{ info.attach[0].name }}</div>
              </div>
              <div class="videoContent" v-if="info && info.videoUrl">
                  <video controls>
                    <source :src="info.videoUrl" type="video/mp4">
                  </video>
              </div>
          </div>
      </div>
      <div class="pd_paginationNewsContent e-flex">
        <div class="pd_paginationWhiteContent">
            <div class="changePageList e-flex" v-if="prev" @click="changeList(prev)">
              <img class="pageCHangeIcon" src="@/assets/images/ic_top.png">
              <div class="changePageLabel">上一篇</div>
              <div class="changePageCommon e-line-1">{{ prev ? prev.title : '' }}</div>
            </div>
            <div class="changePageList e-flex" v-if="next" @click="changeList(next)">
              <img class="pageCHangeIcon" src="@/assets/images/ic_down.png">
              <div class="changePageLabel">下一篇</div>
              <div class="changePageCommon e-line-1">{{ next ? next.title : '' }}</div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import '../../styles/twoRegionPolicy.css'
  export default {
    name: 'regionPolicyDetail',
    data () {
      return {
        from: '',
        id: '',
        info: null,
        prev: null,
        next: null,
        searchType: 1,
        searchName: ''
      }
    },
    created() {
      this.from = this.$route.query.from
      this.id = this.$route.query.id
      this.searchType = this.$route.query.searchType
      this.searchName = this.$route.query.searchName
      this.getDetail()
      this.getLastNext()
    },
    methods: {
      goMainPage() {
        this.$emit('goNavPage', {
          key:'1',
          path: ['1'],
            pathId: '1'
        })
      },
      getDetail() {
        this.request({
            url: 'policy/detail',
            method: 'POST',
            data: {
              id: this.id
            }
        }).then(res => {
            this.info = res.data
            if (this.searchName) {
                if (this.searchType == 1) {
                  this.info.title = this.info.title.replaceAll(this.searchName,'<span style="color: #008CFF">' +this.searchName+ '</span>')
                } else if (this.searchType == 2) {
                  this.info.content = this.info.content.replaceAll(this.searchName,'<span style="color: #008CFF !important">' +this.searchName+ '</span>')
                }
              }
        })
      },
      viewPdf(url) {
        window.open(url)
      },
      getLastNext() {
        this.request({
            url: 'policy/lastNext',
            method: 'POST',
            data: {
              id: this.id,
              type: 1
            }
        }).then(res => {
          res.data.forEach((item, index, array) => {
            if (item.id > this.id) {
              this.prev = item
            } else {
              this.next = item
            }
          })
        })
      },
      changeList(item) {
        this.id = item.id
        this.prev = null
        this.next = null
        this.getDetail()
        this.getLastNext()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/twoRegionPolicy/policyInterpretationDetail.vue